module.exports = __webpack_public_path__ + "img/logo.a5476569.png";